var _path, _path2, _path3, _marker, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUs = function SvgUs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 480"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#bd3d44",
    d: "M0 0h640v480H0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 37,
    d: "M0 55.3h640M0 129h640M0 203h640M0 277h640M0 351h640M0 425h640"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#192f5d",
    d: "M0 0h364.8v258.5H0"
  })), _marker || (_marker = /*#__PURE__*/React.createElement("marker", {
    id: "us_svg__a",
    markerHeight: 30,
    markerWidth: 30
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m14 0 9 27L0 10h28L5 27z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    markerMid: "url(#us_svg__a)",
    d: "m0 0 16 11h61 61 61 61 60L47 37h61 61 60 61L16 63h61 61 61 61 60L47 89h61 61 60 61L16 115h61 61 61 61 60L47 141h61 61 60 61L16 166h61 61 61 61 60L47 192h61 61 60 61L16 218h61 61 61 61 60z"
  })));
};
export default SvgUs;